// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format0 } from '../../constants';

/** Sint Maarten */
const SX: PhoneNumberData = [1, 'SX', 10, format0, /^(?:721)/];

export default SX;
